import React from "react";
import SectionWidgetHeader from "./SectionWidgetHeader";
import SectionWidgetMain from "./SectionWidgetMain";

const SectionWidget = ({
  firstMountRef,
  msgId,
  widget,
  widgetId,
  dashboardId,
  sectionId,
}) => {
  const { label } = widget;

  return (
    <div className="bg-zinc-900 rounded-md p-2">
      <SectionWidgetHeader
        widgetLabel={label}
        widgetId={widgetId}
        dashboardId={dashboardId}
        sectionId={sectionId}
      />

      <SectionWidgetMain
        msgId={msgId}
        widgetId={widgetId}
        dashboardId={dashboardId}
        sectionId={sectionId}
        firstMountRef={firstMountRef}
      />
    </div>
  );
};

export default SectionWidget;
